import React from "react";
import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import EditorFormSection from "../../EditorFormSection";
import ColorSelect from "../../ColorSelectForHookForm";

const ColorSection = ({ isOpen, togglePanel }, context) => {
  const { control, watch } = useFormContext(); // Access form context from React Hook Form
  const materialSerie = watch("materialSerie"); // Watch for changes in materialSerie

  return (
    <EditorFormSection
      help={context.t("FileEditor.color.help")}
      panelName="color"
      panelTitle={context.t("Which color should your foil have?")}
      open={isOpen}
      toggle={togglePanel}
    >
      <Controller
        name="color"
        control={control}
        render={({ field }) => (
          <ColorSelect {...field} materialSerie={materialSerie} />
        )}
      />
    </EditorFormSection>
  );
};

ColorSection.contextTypes = {
  t: PropTypes.func,
};

ColorSection.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  togglePanel: PropTypes.func.isRequired,
};

export default ColorSection;
